import { queryOptions } from '@tanstack/react-query';

import { ONE_MINUTE } from '@/constants/time';
import { paths } from '@primum/api-types';
import { fetchClient } from '@/util/fetchClient';

export type MyPublicLinkV2 = NonNullable<
  paths['/v2/users/me/public-link']['get']['responses'][200]['content']['application/json']['data']
>;

/**
 * The signed-in expert's personal link. The first read assigns a slug from
 * their name, so an expert never sees an empty state. Experts cannot change
 * it; support renames a slug from admin when a name is shortened or changes.
 */
export async function getMyPublicLinkV2(): Promise<MyPublicLinkV2> {
  const { data } = await fetchClient.GET('/v2/users/me/public-link');

  if (!data?.data) {
    throw new Error('Personal link unavailable');
  }

  return data.data;
}

export const getMyPublicLinkV2QueryOptions = (userId?: number | string) =>
  queryOptions<MyPublicLinkV2>({
    queryKey: ['myPublicLinkV2', userId],
    queryFn: getMyPublicLinkV2,
    staleTime: ONE_MINUTE,
    enabled: !!userId,
    retry: false,
  });
